export default "__VITE_ASSET__d199ea06__"